export const ProcedureObject = {
    "resourceType": "Procedure",
    "id": "example",
    "text": {
      "status": "generated",
      "div": "\u003cdiv xmlns\u003d\"http://www.w3.org/1999/xhtml\"\u003eRoutine Appendectomy\u003c/div\u003e"
    },
    "status": "completed",
    "code": {
      "coding": [
        {
          "system": "http://snomed.info/sct",
          "code": "80146002",
          "display": "Appendectomy (Procedure)"
        }
      ],
      "text": "Appendectomy"
    },
    "subject": {
      "reference": "Patient/example"
    },
    "performedDateTime": "2013-04-05",
    "recorder": {
      "reference": "Practitioner/example",
      "display": "Dr Cecil Surgeon"
    },
    "asserter": {
      "reference": "Practitioner/example",
      "display": "Dr Cecil Surgeon"
    },
    "performer": [
      {
        "actor": {
          "reference": "Practitioner/example",
          "display": "Dr Cecil Surgeon"
        }
      }
    ],
    "reasonCode": [
      {
        "text": "Generalized abdominal pain 24 hours. Localized in RIF with rebound and guarding"
      }
    ],
    "followUp": [
      {
        "text": "ROS 5 days  - 2013-04-10"
      }
    ],
    "note": [
      {
        "text": "Routine Appendectomy. Appendix was inflamed and in retro-caecal position"
      }
    ],
    "meta": {
      "tag": [
        {
          "system": "http://terminology.hl7.org/CodeSystem/v3-ActReason",
          "code": "HTEST",
          "display": "test health data"
        }
      ]
    }
  }